import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { LanguageProvider } from "./context/LanguageContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import store from "./app/store";
import { fetchSettings } from "./features/settings/settingsSlice";
import "./App.css";

// Halaman utama
import Home from "./pages/Home";
import WhyUs from "./pages/WhyUs";
import Team from "./pages/Team";
import Clients from "./pages/Clients";
import Activities from "./pages/Activities";
import ActivityDetail from "./pages/ActivityDetail"; // ✅ Tambahkan komponen detail

// Komponen pembungkus utama
const AppContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  return (
    <div className="App flex flex-col min-h-screen">
      {/* Navigasi */}
      <Navigation />

      {/* Konten utama */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/team" element={<Team />} />
          <Route path="/clients" element={<Clients />} />
          {/* Daftar aktivitas */}
          <Route path="/activities" element={<Activities />} />
          {/* ✅ Halaman detail aktivitas berdasarkan slug */}
          <Route path="/activities/:slug" element={<ActivityDetail />} />
          {/* Watch Price page */}
          <Route path="/watch-price" element={React.createElement(require('./pages/WatchPrice').default)} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <LanguageProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </LanguageProvider>
      </Provider>
    </React.StrictMode>
  );
}

export default App;
